/* 
 When the facebook pixel initializes it gets user traits (email, etc.) via analytics.user().traits()
 The pixel does not pick up changes from subsequent analytics.identify() calls until the next page load.
 This is problematic because it means purchase events for new trialers won't include email, firstName, etc.
 because those traits are set after initialization (via identify).

 To remedy this we're manually updating the pixel's userData.
 */

export async function updateFacebookPixelUserData(userStatusInfo) {
  if (!userStatusInfo?.email) {
    return;
  }

  global.fbq?.getState?.()?.pixels.forEach(({ id }) => {
    try {
      const px = global.fbq.instance.getPixel(id);

      const {
        email,
        firstName = px?.userData?.firstName,
        lastName = px?.userData?.lastName,
      } = userStatusInfo;

      px.userData = { ...px?.userData, email, firstName, lastName };
    } catch (error) {
      // we don't care if it errors
    }
  });
}
